import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { useTranslation } from "react-i18next";

import { useUnsavedChanges } from "~/providers/unsaved-changes-provider";
import { useProductModifierStore } from "~/stores/use-product-modifier-store";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { ScrollArea } from "../ui/scroll-area";
import { ModifierForm } from "./modifier-form";

export default function ModifierDialog() {
  const {
    productModifierFormOpen,
    setProductModifierFormOpen,
    selectedProductModifier,
    setSelectedProductModifier,
  } = useProductModifierStore();

  const { checkUnsavedChanges } = useUnsavedChanges();

  const { t } = useTranslation("common");

  const handleDialog = (open: boolean, force?: boolean) => {
    if (open === false) {
      if (force !== true) {
        const result = checkUnsavedChanges();
        if (result === true) return;
      }
      setSelectedProductModifier(undefined);
    }
    setProductModifierFormOpen(open);
  };

  return (
    <Dialog open={productModifierFormOpen} onOpenChange={handleDialog}>
      <DialogContent className="max-w-2xl w-full">
        <DialogHeader>
          <DialogTitle>{t("ProductModifier.product_modifier")}</DialogTitle>
          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        <div className="max-h-[80vh] p-4 overflow-auto small-scrollbar">
          <ModifierForm
            onClose={(force) => handleDialog(false, force)}
            modifier={selectedProductModifier}
          />
        </div>
        <DialogFooter>
          <Button type="submit" form="product-modifier-form" variant="success">
            {selectedProductModifier ? t("update") : t("create")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
